import CloseIcon from "@mui/icons-material/Close";
import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import { reduce } from "et3-type-guards";
import i18n from "../../constants/i18n";
import getCorePopUpStore from "../../stores/core/core-popup-store";
import getUserAdvancedStore from "../../stores/user-store/advanced-store";
import { withLiteObserverAndTheme } from "../et3-enhanced-render";
import PictureStatusIcon from "./PictureStatusIcon";
import SelfieVerifiedIcon from "./SelfieVerifiedIcon";

const KhattabatAlbumDialog = withLiteObserverAndTheme(() => {
  const { isPicAlbumPopUpVisible, closePicAlbumPopUp } = getCorePopUpStore();
  const {
    currentUserId,
    userData,
    getImageData,
    getImageSource,
    getPictureBorderColor
  } = getUserAdvancedStore();
  const pictures = reduce(() => userData.get(currentUserId.get()).pictures, []);

  return (
    <Dialog
      open={isPicAlbumPopUpVisible.get()}
      onClose={closePicAlbumPopUp}
      fullWidth
      maxWidth="md"
    >
      <DialogTitle>
        <Stack direction="row" alignItems="center">
          <Box sx={{ flex: 1 }}>{i18n.get("USER_ALBUM_PICTURES")}</Box>
          <IconButton
            aria-label={i18n.get("KHATTABAT_CLOSE")}
            onClick={closePicAlbumPopUp}
          >
            <CloseIcon />
          </IconButton>
        </Stack>
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          {pictures.map((picture, index) => {
            const {
              isPictureActive,
              selfieVerified,
              profilePictureStatus,
              source
            } = getImageData(picture);
            return (
              <Grid key={index} size={{ xs: 6, sm: 4, md: 3 }}>
                <Box sx={{ position: "relative" }}>
                  <Box
                    component="img"
                    src={source}
                    alt={i18n.get("USER_ALBUM_PICTURES")}
                    sx={{
                      width: "100%",
                      aspectRatio: "1",
                      objectFit: "cover",
                      borderRadius: 2,
                      border: 2,
                      borderColor: getPictureBorderColor(profilePictureStatus),
                      opacity: isPictureActive ? 1 : 0.5
                    }}
                  />
                  {selfieVerified === "Y" ? (
                    <Box sx={{ position: "absolute", top: 4, left: 4 }}>
                      <SelfieVerifiedIcon />
                    </Box>
                  ) : null}
                  <Box sx={{ position: "absolute", top: 4, right: 4 }}>
                    <PictureStatusIcon
                      statusImage={getImageSource(
                        isPictureActive,
                        profilePictureStatus
                      )}
                    />
                  </Box>
                </Box>
              </Grid>
            );
          })}
        </Grid>
      </DialogContent>
    </Dialog>
  );
});

export default KhattabatAlbumDialog;
